export default __webpack_public_path__ + "images/2e2ebfa7cd0d3a73c5d3df3a2e80a710-datamart-logo-admin.svg";